import React, { memo } from "react";
import Input from "components/formikcontrols/input/Input";
import Password from "components/formikcontrols/password/Password";
import Select from "components/formikcontrols/select/Select";
import Textarea from "components/formikcontrols/textarea/Textarea";
import Date from "components/formikcontrols/date/Date";
import Time from "./time/Time";
import RadioGroup from "./radiogroup/RadioGroup";
import Upload from "./uploads/Uploads";
import Checkbox from "./checkbox/Checkbox";
import ChecBoxSelect from "./checkboxSelect/CheckBoxSelect";
import UploadMultiple from "components/uploadsMultiple/UploadsMultiple";

const FormikControl = (props) => {
  const { control, ...rest } = props;

  switch (control) {
    case "input":
      return <Input {...rest} />;
    case "password":
      return <Password {...rest} />;
    case "select":
      return <Select {...rest} />;
    case "textarea":
      return <Textarea {...rest} />;
    case "date":
      return <Date {...rest} />;
    case "time":
      return <Time {...rest} />;
    case "radio":
      return <RadioGroup {...rest} />;
    case "checkbox":
      return <Checkbox {...rest} />;
    case "upload":
      return <Upload {...rest} />;
    case "uploadMultiple":
      return <UploadMultiple {...rest} />;
    case "checkboxSelect":
      return <ChecBoxSelect {...rest} />;
    default:
      return null;
  }
};

export default memo(FormikControl);
